// import { CONNECT_API_BASE_URL } from '../env';

// const connectAPI = (path, params, method, token, domainUrl, isFormData) => {
//   let options;
//   options = {
//     headers: {
//       Accept: 'application/json',
//       'Content-Type': !isFormData ? 'application/json' : 'multipart/form-data',
//       ...(token && { 'X-AUTH-TOKEN': `${token}` }),
//     },
//     method: method,
//     ...(params && { body: isFormData ? params : JSON.stringify(params) }),
//   };
//   let baseUrl = domainUrl ? domainUrl : CONNECT_API_BASE_URL;
//   console.log(
//     'Connect URL---------->',
//     baseUrl + path,
//     options,
//     isFormData || false,
//   );
//   return fetch(baseUrl + path, options)
//     .then(resp => resp)
//     .catch(error => error);
// };

// export default connectAPI;
import { CONNECT_API_BASE_URL } from '../env';

const connectAPI = (path, params, method, token, domainUrl, isFormData, isPass) => {
  let options;
  options = {
    headers: {
      Accept: 'application/json',
      ...(!isPass && {'Content-Type': !isFormData ? 'application/json' : 'multipart/form-data'}),
      ...(token && { 'X-AUTH-TOKEN': `${token}` }),
    },
    method: method,
    ...(params && { body: isFormData ? params : JSON.stringify(params) }),
  };
  let baseUrl = domainUrl ? domainUrl : CONNECT_API_BASE_URL;
  // console.log(
  //   'Connect URL---------->',
  //   baseUrl + path,
  //   options,
  //   isFormData || false,
  // );
  return fetch(baseUrl + path, options)
    .then(resp => resp)
    .catch(error => {
      console.log("Error: " , error);
    });
};

export default connectAPI;
